import React from 'react';
import { useAuth } from '../context/AuthContext';

const SessionExpiredDialog: React.FC = () => {
    const { isSessionExpired, closeSessionExpiredDialog } = useAuth();

    if (!isSessionExpired) {
        return null;
    }

    return (
        <div className="session-expired-overlay">
            <div className="card session-expired-card">
                <div className="card-body text-center">
                    <h4 className="heading mb-3" style={{ fontSize: '24px' }}>Session Expired</h4>
                    <p className="mb-4 session-expired-text">
                        Your session has expired. Please log in again to continue.
                    </p>
                    <button
                        className="btn btn-primary w-100"
                        onClick={closeSessionExpiredDialog}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredDialog;
